import SocialMediaType from '@/enums/SocialMediaType';

const state = {
  reviews: [],
  isLoadingMediaReviewSummary: true
};

const MEDIA_SUMMARY_MAX_REVIEWS_PC = 12;
const MEDIA_SUMMARY_MAX_REVIEWS_MOBILE = 10;
const getters = {
  reviewMedia({ reviews }, _getters, { widget: { isMobile } }, rootGetters) {
    const media = [];
    reviews.forEach((review, index) => {
      const mediaCount =
        review.social_media_type === SocialMediaType.INSTAGRAM
          ? 1
          : review.videos.length + review.images.length;
      for (let i = 0; i < mediaCount; ++i) {
        media.push({
          review: rootGetters['review/displayableReview'](review),
          media_position: i + 1,
          review_index: index
        });
      }
    });

    return media.slice(
      0,
      isMobile ? MEDIA_SUMMARY_MAX_REVIEWS_MOBILE : MEDIA_SUMMARY_MAX_REVIEWS_PC
    );
  }
};

const mutations = {
  SET_REVIEWS(state, reviews) {
    state.reviews = reviews;
  },
  SET_IS_LOADING_MEDIA_REVIEW_SUMMARY(state, isLoadingMediaReviewSummary) {
    state.isLoadingMediaReviewSummary = isLoadingMediaReviewSummary;
  }
};

const actions = {
  fetchProductMediaReviewSummary({ commit, rootState }) {
    const product_code = rootState.productCode;
    const widget_id = rootState.widget.widget.id;
    commit('SET_IS_LOADING_MEDIA_REVIEW_SUMMARY', true);
    const per = rootState.widget.isMobile
      ? MEDIA_SUMMARY_MAX_REVIEWS_MOBILE
      : MEDIA_SUMMARY_MAX_REVIEWS_PC;
    rootState.api
      .fetchProductMediaReviews(product_code, { widget_id, per })
      .then(({ data }) => {
        commit('SET_REVIEWS', data.reviews);
      })
      .finally(() => {
        commit('SET_IS_LOADING_MEDIA_REVIEW_SUMMARY', false);
      });
  }
};

export default { namespaced: true, state, getters, mutations, actions };
